module.exports = __webpack_public_path__ + "static/media/music.64444b39.png";